import { render, staticRenderFns } from "./selectMessageUser.vue?vue&type=template&id=2196f202&scoped=true&"
import script from "./selectMessageUser.vue?vue&type=script&lang=js&"
export * from "./selectMessageUser.vue?vue&type=script&lang=js&"
import style0 from "./selectMessageUser.vue?vue&type=style&index=0&id=2196f202&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196f202",
  null
  
)

export default component.exports